import { render } from "./Resend.vue?vue&type=template&id=ca9ab5ae"
import script from "./Resend.vue?vue&type=script&lang=js"
export * from "./Resend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__